import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

let fpLoaderPromise = null;

/**
 * Initializes and retrieves the FingerprintJS RequestID.
 * Uses the Singleton pattern to avoid reloading the script on each call.
 * @returns {Promise<string>} The generated requestId or an error/status string.
 */
export async function useFingerprint() {
    if (process.env.VUE_APP_FINGERPRINT_ENABLED !== 'true') {
        return 'fingerprint_disabled';
    }

    let requestIdFingerPrint;

    try {
        const apiKey = process.env.VUE_APP_FINGERPRINT_API_KEY;
        
        if (!apiKey) {
            throw new Error('API Key is missing');
        }

        const options = {
            apiKey: apiKey
        };

        const useEndpoint = process.env.VUE_APP_FINGERPRINT_USE_ENDPOINT === 'true';

        if (useEndpoint) {
            if (!process.env.VUE_APP_FINGERPRINT_ENDPOINT || !process.env.VUE_APP_FINGERPRINT_PATH) {
                throw new Error('Endpoint configuration missing');
            }
            options.endpoint = [process.env.VUE_APP_FINGERPRINT_ENDPOINT];
            options.scriptUrlPattern = [
                `${process.env.VUE_APP_FINGERPRINT_PATH}?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>`
            ];
        }

        if (!fpLoaderPromise) {
            fpLoaderPromise = FingerprintJS.load(options);
        }

        const fp = await fpLoaderPromise;
        const result = await fp.get();

        if (!result || !result.requestId) {
            throw new Error('FingerprintJS returned invalid result');
        }

        requestIdFingerPrint = result.requestId;

    } catch (error) {
        const errorMessage = error.message || 'Unknown error';
        console.error('FingerprintJS Error:', errorMessage);

        fpLoaderPromise = null;
        requestIdFingerPrint = 'fingerprint_error';
    }

    return requestIdFingerPrint;
}